import { LastSalePointLocalStorageRepository } from '@/components/modules/Application/IberiaCards/modules/SalePointAndProduct/entities/LastSalePointRepository/LastSalePointLocalStorageRepository';
import { LastSalePointRepository } from '@/components/modules/Application/IberiaCards/modules/SalePointAndProduct/entities/LastSalePointRepository/LastSalePointRepository';

export class LastSalePointRepositoryFactory {
  public static getRepository(): LastSalePointRepository {
    return new LastSalePointLocalStorageRepository();
  }
}
